import React, { useEffect, useState } from "react";
import { Button, Col, Row } from "react-bootstrap";
import TopNavBar from "../Layout/TopNavBar";
import { callApi } from "../utills/api";
import { showError, showSuccess } from "../utills/sweetAlert";
import { TagInput } from "rsuite";
import "rsuite/dist/rsuite.min.css";

const Info: React.FC = () => {
  const [InfoDetails, setInfoDetails] = useState<any[]>([]);
  const [phoneNumbers, setPhoneNumbers] = useState<string[]>([]);
  const [emails, setEmails] = useState<string[]>([]);
  const [emailError, setEmailError] = useState("");
  const [phoneNumberError, setPhoneNumberError] = useState("");

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    if (InfoDetails.length > 0) {
      const { phoneNumber, email } = InfoDetails[0];
      setPhoneNumbers(phoneNumber.split(","));
      setEmails(email.split(","));
    }
  }, [InfoDetails]);

  const getData = () => {
    callApi("GET", "infoSelect.php", "")
      .then((res) => res.data)
      .then((response) => {
        if (response) {
          setInfoDetails(response.data);
        }
      })
      .catch((err: any) => {
        console.error(
          "API call error:",
          err.response ? err.response.data.error : err.message
        );
        showError(
          "Failed",
          err.response ? err.response.data.error : err.message
        );
      });
  };

  const handlePhoneNumberChange = (value: readonly string[]) => {
    const invalidNumbers = value.filter((num) => !/^\d{10}$/.test(num));
    if (value.length <= 2) {
      if (invalidNumbers.length > 0) {
        setPhoneNumberError("Each phone number must be exactly 10 digits.");
      } else {
        setPhoneNumbers(value as string[]);
        setPhoneNumberError("");
      }
    } else {
      setPhoneNumberError("You can add up to 2 phone numbers only.");
    }
  };
  
  const handleEmailChange = (value: readonly string[]) => {
    const invalidEmails = value.filter(
      (email) => !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email)
    );
    if (value.length <= 2) {
      if (invalidEmails.length > 0) {
        setEmailError("Invalid email format.");
      } else {
        setEmails(value as string[]);
        setEmailError("");
      }
    } else {
      setEmailError("You can add up to 2 emails only.");
    }
  };
  


  const handleSubmit = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    let isValid = true;
if (phoneNumbers.length === 0) {
    setPhoneNumberError("Phone number is required.");
    isValid = false;
  } else if (!phoneNumbers.every((num) => /^\d+$/.test(num))) {
    setPhoneNumberError("Phone numbers must contain only numeric characters.");
    isValid = false;
  } else if (!phoneNumbers.every((num) => /^\d{10}$/.test(num))) {
    setPhoneNumberError("Each phone number must be exactly 10 digits.");
    isValid = false;
  }
    if (emails.length === 0) {
      setEmailError("Email is required.");
      isValid = false;
    } else if (
      !emails.every(
        (email) =>
          /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email)
      )
    ) {
      setEmailError("Invalid email format.");
      isValid = false;
    }

    if (!isValid) return;

    const request = {
      phoneNumber: phoneNumbers, // Send as comma-separated string
      email: emails,
    };

    callApi("POST", "infoUpdate.php", request)
      .then((res) => res.data)
      .then((response) => {
        if (response) {
          showSuccess("Success!", "Info Updated Successfully!");
          getData();
        setEmailError("");
        setPhoneNumberError("");

        }
      })
      .catch((err: any) => {
        console.error(
          "API call error:",
          err.response ? err.response.data.error : err.message
        );
        showError(
          "Failed",
          err.response ? err.response.data.error : err.message
        );
      });
  };

  return (
    <>
      <div>
        <div className="mobile_nav_bar">
          <TopNavBar />
        </div>
        <div className="">
          <Row className="webview">
            <div className="category-header">
              <Col lg="8" md="8">
                <h3 className="category-title">Info</h3>
              </Col>
            </div>
          </Row>
        </div>

        <div className="element-container">
          <form>
            <Row>
              <Col lg="6" md="6">
                <h5>Phone Numbers:</h5>
                <TagInput
                  value={phoneNumbers}
                  onChange={handlePhoneNumberChange}
                  placeholder="Add phone numbers"
                  style={{ width: "100%" }}
                  aria-required
                />
                {phoneNumberError && (
                  <div style={{ color: "red", marginTop: "5px" }}>
                    {phoneNumberError}
                  </div>
                )}
              </Col>
              <Col lg="6" md="6">
                <h5>Email:</h5>
                <TagInput
                  value={emails}
                  onChange={handleEmailChange}
                  placeholder="Add email"
                  style={{ width: "100%" }}
                  aria-required
                  
                />
                {emailError && (
                  <div style={{ color: "red", marginTop: "5px" }}>
                    {emailError}
                  </div>
                )}
              </Col>

              <Col lg="2" md="2">
                <button
                  className="btn btn-primary modalsubbutton mt-3 mb-3"
                  type="button"
                  onClick={handleSubmit}
                >
                  Update
                </button>
              </Col>
            </Row>
          </form>
        </div>
      </div>
    </>
  );
};

export default Info;
